import { UserManager, WebStorageStateStore, Log } from 'oidc-client-ts'

Log.setLogger(console);
Log.setLevel(Log.DEBUG);

const { protocol, hostname, port } = window.location

const origin = `${protocol}//${hostname}${port ? `:${port}` : ''}`

const oidcConfig = {
	authority: process.env.REACT_APP_AUTHORITY!,
	client_id: 'system-orderjp-client',
	redirect_uri: `${origin}/callback`,
	post_logout_redirect_uri: origin,
    silent_redirect_uri: `${origin}/silent_renew.html`,
	response_type: 'code',
	scope: 'openid profile email offline_access',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: false,
    revokeAccessTokenOnSignout: true,
	userStore: new WebStorageStateStore({ store: window.localStorage }),
}

export const userManager = new UserManager(oidcConfig)
